export default "__VITE_ASSET__CE2gfaD9__"